import { useState } from "react";

import Autocomplete from "@/components/forms/Autocomplete/Autocomplete";
import Flex from "../../../components/Flex/Flex";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import styles from "./CreateNewBoxButton.module.css";
import { BoxTemplate, FbaBox, FbaShipment, useShipmentContext } from "@/contexts/ShipmentContext";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { handleCreateBox } from "@/api/fulfillment";
import InputNumber from "../../../components/forms/InputNumber/InputNumber";
import Button from "../../../components/forms/Button/Button";
import { useErrorModalContext } from "@/contexts/ErrorModalContext";
import { TransportType } from "@boxem/core-api-schema";

export type CreateNewBoxButtonProps = {
  createBoxes: (n: number, templateId: string|null) => Promise<void>;
  black?: boolean;
};

export function CreateNewBoxButton(props: CreateNewBoxButtonProps) {
  const { boxTemplates } = useShipmentContext();
  const [ numberOfBoxesToCreate, setNumberOfBoxesToCreate ] = useState<number>(1);
  const [ selectedTemplateId, setSelectedTemplateId ] = useState<string|null>(null);
  const defaultBox: BoxTemplate|null = boxTemplates.templates.find(b => b.id == boxTemplates.defaultBoxTemplateId);
  const selectedBox: BoxTemplate|null = selectedTemplateId ? boxTemplates.templates.find(b => b.id == selectedTemplateId) : null;
  const boxToCreate = selectedBox ?? defaultBox ?? null;
  const boxStringToCreate: string = boxToCreate ? (boxToCreate.length + "x" + boxToCreate.width + "x" + boxToCreate.height + " " + (Math.round(boxToCreate.weight*16)/16) + "lbs") : "Create a box";
  const defaultBoxStringToCreate: string = defaultBox ? (defaultBox.length + "x" + defaultBox.width + "x" + defaultBox.height + " " + (Math.round(defaultBox.weight*16)/16) + "lbs") : "Create a box";
  return (
    <div className={styles.createNewBoxButtonContainer} style={{display: "flex", alignItems:"center", flexDirection: "row", gap: "10px"}}>
      <Tooltip title={boxStringToCreate} delayMs={50} placement="left">
      <Autocomplete
        placeholder={(defaultBox && (!defaultBox.isAutoGenerated)) ? (`Default (${defaultBox.name})`) : "Default box"}
        options={["", ...boxTemplates.templates.filter(t => !t.isAutoGenerated).map(t => t.id)]}
        optionRender={id => {
          let template: BoxTemplate|null = (id && boxTemplates.templates.find(t => t.id === id)) ?? null;
          if(!template) {
            template = {...defaultBox};
            template.name = "Default";
          }
          if(template) {
            return (
              <Tooltip placement="left" delayMs={50} title={template.length + "x" + template.width + "x" + template.height + " " + template.weight + "lbs"}><div style={{width: "100%", padding:"10px", margin: "-10px"}}>{template.name}</div></Tooltip>
            );
          } else return "???";
        }}
        value={selectedTemplateId}
        onChange={e => {
          setSelectedTemplateId(e);
        }}
        style={{width:"9.5rem"}}
        getFilterProperty={ (option) => { return boxTemplates.templates.find(test => test.id === option)?.name ?? "Default"; } }
        optionToDisplayString={t => {
          const found: BoxTemplate|null = (t && boxTemplates.templates.find(test => test.id === t)) ?? null;
          if(found) return found.name;
          else return "";
        }}
        onCreateNewOption={ (value: string) => { setSelectedTemplateId(null); return true; } }
      />
      </Tooltip>
      <InputNumber
        min={1}
        max={50}
        value={numberOfBoxesToCreate}
        onChange={value => setNumberOfBoxesToCreate(value)}
        style={{width: "6.5rem" }}
      />
      <Button
        type={props.black ? "black" : "secondary"}
        disableWhileOnClick={true}
        onClick={() => props.createBoxes(numberOfBoxesToCreate, selectedTemplateId)}
      >
        Create boxes
      </Button>
    </div>
  );
}
